export default "__VITE_ASSET__CXILX$Q0__"